import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=09ff5cd9&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=ts"
export * from "./SideBarItem.vue?vue&type=script&lang=ts"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=09ff5cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff5cd9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseText: require('/home/runner/work/jafolders-web-customer/jafolders-web-customer/components/atoms/BaseText.vue').default})
